import { render, staticRenderFns } from "./StudentHome.vue?vue&type=template&id=7090aa24&"
import script from "./StudentHome.vue?vue&type=script&lang=js&"
export * from "./StudentHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports